module.exports = __webpack_public_path__ + "img/australia-genitourinary-diseases-male.ad8b757c.png";